// Strings in this list correspond to icon names in clients/vuetify/public/assets/icons.
export const customIconNames = [
  'ae-logo',
  'archive-24px',
  'archive-retry',
  'audition-logo',
  'av_sync',
  'av_unsync',
  'download-image-24px',
  'download-new-part-24px',
  'download-subtitles-1-24px',
  'download-to-storage-1-24px',
  'folder-import',
  'icon-folder-search',
  'icon-folder-search-filled',
  'icon-magnet-off',
  'icon-magnet-on',
  'locked',
  'mark-in-24px',
  'mark-in-goto-24px',
  'mark-out-24px',
  'mark-out-goto-24px',
  'me-logo',
  'mimir-cutter-1-at-end',
  'mimir-cutter-2-near-cti',
  'mimir-cutter-3-cut-at-cti',
  'mimir-logo',
  'new-relic-16',
  'premiere-logo',
  'prproj',
  'ps-logo',
  'recently-previewed',
  'recently-previewed-fill',
  'ripple',
  'roll',
  'save-as',
  'shape-rectangle-plus',
  'split_scene_cut_left',
  'split_scene_cut_right',
  'step-backward',
  'step-forward',
  'storage-location-dark',
  'storage-location-light',
  'subclip',
  'subclip-downloaded',
  'subclip-plus',
  'subclip-plus-arrow',
  'subclip-to-storage',
  'unlocked',
  'unpin_item',
  'video_quality_edit',
  'video_quality_edit_seg',
  'video_quality_original',
  'video_quality_original_seg',
  'video_quality_web',
  'video_quality_web_seg',
  'with-audio-24',
  'with-video-24',
  'without-audio-24',
  'without-video-24',
  'zoom-fit',
  'zoom-natural',
] as const;

export const customIconNameSet = new Set<string>(customIconNames);

// Raster-only icons that have no SVG equivalent and must be rendered as an
// <img>. These cannot be recoloured via CSS mask, unlike the SVG icons above.
// Strings correspond to .png names in clients/vuetify/public/assets/icons.
export const customPngIconNames = [
  'dvr-logo',
  'premiere-sequence',
] as const;

export const customPngIconNameSet = new Set<string>(customPngIconNames);